import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Home } from './pages/Home';
import { AdminLogin } from './pages/AdminLogin';
import { AdminPanel } from './pages/AdminPanel';
import { ChatBot } from './components/ChatBot';
import { RequireAuth } from './components/RequireAuth';
import { MobileLayout } from './components/MobileLayout';
import { Onboarding } from './pages/Onboarding';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Barbers } from './pages/Barbers';
import { BarberProfile } from './pages/BarberProfile';
import { Services } from './pages/Services';
import { BookingPage } from './pages/BookingPage';
import { MyAppointments } from './pages/MyAppointments';
import { Profile } from './pages/Profile';
import { Notifications } from './pages/Notifications';
import { Settings } from './pages/Settings';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-black text-light font-sans" data-id="element-1">
        <Routes data-id="element-2">
          {/* Client Auth & Onboarding */}
          <Route path="/onboarding" element={<Onboarding data-id="element-4" />} data-id="element-3" />
          <Route path="/login" element={<Login data-id="element-6" />} data-id="element-5" />
          <Route path="/registro" element={<Register data-id="element-8" />} data-id="element-7" />

          {/* Client Main App (Mobile Layout) */}
          <Route path="/" element={<MobileLayout data-id="element-10">
                <Home data-id="element-11" />
              </MobileLayout>} data-id="element-9" />
          <Route path="/barberos" element={<MobileLayout data-id="element-13">
                <Barbers data-id="element-14" />
              </MobileLayout>} data-id="element-12" />
          <Route path="/barberos/:id" element={<MobileLayout data-id="element-16">
                <BarberProfile data-id="element-17" />
              </MobileLayout>} data-id="element-15" />
          <Route path="/servicios" element={<MobileLayout data-id="element-19">
                <Services data-id="element-20" />
              </MobileLayout>} data-id="element-18" />
          <Route path="/mis-turnos" element={<MobileLayout data-id="element-22">
                <MyAppointments data-id="element-23" />
              </MobileLayout>} data-id="element-21" />
          <Route path="/perfil" element={<MobileLayout data-id="element-25">
                <Profile data-id="element-26" />
              </MobileLayout>} data-id="element-24" />

          {/* Client Full Screen Pages */}
          <Route path="/reservar" element={<BookingPage data-id="element-28" />} data-id="element-27" />
          <Route path="/notificaciones" element={<Notifications data-id="element-30" />} data-id="element-29" />
          <Route path="/configuracion" element={<Settings data-id="element-32" />} data-id="element-31" />

          {/* Admin */}
          <Route path="/admin" element={<AdminLogin data-id="element-34" />} data-id="element-33" />
          <Route path="/admin/panel" element={<RequireAuth data-id="element-36">
                <AdminPanel data-id="element-37" />
              </RequireAuth>} data-id="element-35" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-39" />} data-id="element-38" />
        </Routes>
        <ChatBot data-id="element-40" />
        <Toaster position="top-center" theme="dark" richColors data-id="element-41" />
      </div>
    </BrowserRouter>;
}